/**
 * @Author: luoob
 * @Date: 2021-10-28 16:03:35
 * @Last Modified by: luoob
 * @Last Modified time: 2021-10-28 16:03:41
 * @Instruduction: 麦媒云服务接口
 */

import xhr from './xhr/index'

class WinpressService {
    /** 麦媒云发布列表 */
    public getWpDemandList(params: any) {
        return xhr({
            method: 'get',
            url: '/maimei_demand/list',
            params: params
        })
    }

    /** 麦媒云发布详情 */
    public getWpDemandDetail(params: any) {
        return xhr({
            method: 'get',
            url: '/maimei_demand',
            params: params
        })
    }

    /** 麦媒云发布详情 */
    public updateWpDemandStatus(params: any) {
        return xhr({
            method: 'put',
            url: '/maimei_demand',
            params: params
        })
    }

    /** 麦媒云文章分类列表 */
    public getArticleTypes(params?: any) {
        return xhr({
            method: 'get',
            url: '/winpress/article/types',
            params: params
        })
    }

    /** 创建麦媒云文章分类 */
    public createArticleType(params: any) {
        return xhr({
            method: 'post',
            url: '/winpress/article/type',
            params: params
        })
    }

    /** 更新麦媒云文章分类 */
    public updateArticleType(params: any) {
        return xhr({
            method: 'put',
            url: '/winpress/article/type',
            params: params
        })
    }

    /** 删除麦媒云文章分类 */
    public deleteArticleType(params: any) {
        return xhr({
            method: 'delete',
            url: '/winpress/article/type',
            params: params
        })
    }

    /** 获取麦媒云文章列表 */
    public getArticleList(params: any) {
        return xhr({
            method: 'get',
            url: '/winpress/articles',
            params: params
        })
    }

    /** 获取麦媒云文章详情 */
    public getArticleDetail(params: any) {
        return xhr({
            method: 'get',
            url: '/winpress/article',
            params: params
        })
    }

    /** 创建麦媒云文章 */
    public createArticle(params: any) {
        return xhr({
            method: 'post',
            url: '/winpress/article',
            params: params
        })
    }

    /** 更新麦媒云文章 */
    public updateArticle(params: any) {
        return xhr({
            method: 'put',
            url: '/winpress/article',
            params: params
        })
    }

    /** 更新麦媒云文章 */
    public deleteArticle(params: any) {
        return xhr({
            method: 'delete',
            url: '/winpress/article',
            params: params
        })
    }

    /** 找人写稿列表 */
    public getArticleDemandList(params: any) {
        return xhr({
            method: 'get',
            url: '/article_demand/list',
            params: params
        })
    }

    /** 找人写稿详情 */
    public getArticleDemandDetail(params: any) {
        return xhr({
            method: 'get',
            url: '/article_demand',
            params: params
        })
    }


    /** 更新找人写稿 */
    public updateArticleDemand(params: any) {
        return xhr({
            method: 'put',
            url: '/article_demand',
            params: params
        })
    }
}

export default new WinpressService()
